<template>
    <section class="login-wrapper">
        <section class="material-half-bg">
            <div class="cover"></div>
        </section>
        <section class="container mt-4">
            <h2 class="text-center">รายการบันทึกการตรวจสอบ <b class="text-danger">ค่าแรงดันก๊าซ</b>
            </h2>
            <h3 class="text-center mb-4">#{{ code }}</h3>

            <div class="text-center">
                <button class="btn btn-warning border-dark btn-lg mb-3"
                    @click="openFormModal">เพิ่มบันทึกการตรวจสอบ</button>
            </div>

            <div class="card mb-3">
                <div class="card-body">

                    <!-- <div v-if="!filteredRecords.length" class="d-flex justify-content-center align-items-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div> -->
                    <!-- <div class="row mb-3">
                        <div class="col-md-6">
                            <label class="form-label">เลือกเดือน</label>
                            <select class="form-select" v-model="selectedMonth">
                                <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}
                                </option>
                            </select>
                        </div>
                    </div> -->

                    <form class="d-md-inline-block form-inline ms-auto me-0 me-md-3 mb-3">
                        <div class="input-group">
                            <select v-model="selectedMonth" class="form-select" required>
                                <option value="" disabled>- เลือกเดือน -</option>
                                <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}
                                </option>
                            </select>

                            <select v-model="selectedYear" class="form-select ms-2" required>
                                <option value="" disabled>- เลือกปี -</option>
                                <option v-for="year in years" :key="year" :value="year">{{ year + 543 }}</option>
                            </select>

                            <button @click.prevent="clearFilters" class="btn btn-secondary" type="button">
                                <i class="bi bi-arrow-clockwise"></i> รีเซ็ต
                            </button>
                        </div>
                    </form>

                    <div v-if="!filteredRecords.length" class="text-center text-danger my-2">
                        <div class="spinner-border align-middle"></div>
                        <strong> Loading...</strong>
                    </div>
                    <div v-else class="table-responsive">

                        <table class="table table-bordered table-striped">
                            <thead class="table-dark text-center">
                                <tr>
                                    <th>วันเวลาที่บันทึก</th>
                                    <th>ชื่อผู้บันทึก</th>
                                    <th>หน่วยงาน</th>
                                    <th>รหัส-ชื่อ</th>
                                    <th>รายการตรวจเช็ค</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="record in filteredRecords" :key="record.id">
                                    <td>{{ formatDateTimeUTC(record.record_date) }} | {{ record.record_time }}</td>
                                    <td>{{ record.recorder }}</td>
                                    <td>{{ record.group?.name }}</td>
                                    <td>{{ record.gas_pressure_value.code }} - {{ record.gas_pressure_value.name }}</td>
                                    <td>
                                        <ul>
                                            <li v-for="item in record.items" :key="item.id">
                                                {{ item.name }} - <span
                                                    :class="item.pivot.status ? 'text-success' : 'text-danger'">
                                                    {{ item.pivot.status ? '✅' : '❌' }}
                                                </span>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            <div class="modal fade" id="Modal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="roleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">บันทึกการตรวจสอบ ถังก๊าซ</h5>
                            <button type="button" class="btn-close" @click="closeFormModal"></button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="handleSubmit">
                                <!-- <div class="row" hidden> -->
                                <div class="row" >
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">วันที่บันทึก (Record Date)</label>
                                            <DatePicker v-model="date" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">เวลา (Record Time)</label>
                                            <TimePicker v-model="time" required />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">หน่วยงาน (Department)</label>
                                    <select disabled v-model="form.group_id" class="form-select" required>
                                        <option value="">- เลือกหน่วยงาน -</option>
                                        <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name
                                            }}</option>
                                    </select>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label">รายการตรวจเช็ค (Checklists)</label>
                                    <div class="form-check" v-for="item in gasInspectionItems" :key="item.id">
                                        <input type="checkbox" class="form-check-input" :id="'item-' + item.id"
                                            :value="{ id: item.id, status: true }" v-model="form.items" />
                                        <label class="form-check-label" :for="'item-' + item.id">{{ item.name }}</label>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label">ชื่อผู้บันทึก (Recorder)</label>
                                    <v-select v-model="form.recorder" :options="doctors" label="name"
                                        :reduce="item => item.name" :clearable="false"
                                        placeholder="ค้นหา..ชื่อผู้บันทึก">
                                        <template #search="{ attributes, events }">
                                            <input class="vs__search" :required="!form.recorder" v-bind="attributes"
                                                v-on="events" />
                                        </template>
                                    </v-select>
                                </div>

                                <hr />
                                <button type="submit" class="btn btn-lg btn-primary w-100">บันทึกข้อมูล (Save)</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </section>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import { showErrorAlert, showSuccessAlert } from '@/utils/sweetalert2-utils';
// import { formatDateTime } from '@/utils/dateUtils';
import axios from 'axios';
import { useRoute } from 'vue-router';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
import moment from 'moment';
import DatePicker from '@/components/DatePicker.vue';
import TimePicker from '@/components/TimePicker.vue';

const modal = ref(null);
const gasInspectionItems = ref([]);
const now = moment();
const form = ref({
    recorder: "",
    group_id: "",
    gas_pressure_values_id: "",
    items: [],
    record_date: now.format('YYYY-MM-DD'),
    record_time: now.format('HH:mm:ss')
});

const date = ref(moment().format('YYYY-MM-DD'));
const time = ref(moment().format('HH:mm:ss'));

const groups = ref([]);
const doctors = ref([]);
const route = useRoute();
const code = ref(route.params.code);
const gasInspectionRecords = ref([]);

const today = new Date();
const selectedMonth = ref(today.getMonth() + 1);
const selectedYear = ref(today.getFullYear());

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - i); // 5 ปีย้อนหลัง
const months = [
    { value: 1, name: 'มกราคม' },
    { value: 2, name: 'กุมภาพันธ์' },
    { value: 3, name: 'มีนาคม' },
    { value: 4, name: 'เมษายน' },
    { value: 5, name: 'พฤษภาคม' },
    { value: 6, name: 'มิถุนายน' },
    { value: 7, name: 'กรกฎาคม' },
    { value: 8, name: 'สิงหาคม' },
    { value: 9, name: 'กันยายน' },
    { value: 10, name: 'ตุลาคม' },
    { value: 11, name: 'พฤศจิกายน' },
    { value: 12, name: 'ธันวาคม' },
];

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
    }
});

// const selectedMonth = ref(new Date().getUTCMonth() + 1); // เดือนปัจจุบัน (UTC)
// const selectedYear = ref(new Date().getUTCFullYear()); // ปีปัจจุบัน (UTC)

// const filteredRecords = computed(() => {
//     return gasInspectionRecords.value
//         .filter(record => {
//             const recordDate = new Date(record.record_date);
//             return (
//                 record.gas_pressure_value.code === code.value &&
//                 recordDate.getUTCMonth() + 1 === selectedMonth.value &&
//                 recordDate.getUTCFullYear() === selectedYear.value
//             );
//         })
//         .sort((a, b) => new Date(b.record_date) - new Date(a.record_date));
// });

const filteredRecords = computed(() => {
    return gasInspectionRecords.value.filter(record => {
        const recordDate = new Date(record.record_date);
        // return (
        //     // record.gas_pressure_value.code === code.value &&
        //     // recordDate.getUTCMonth() + 1 == selectedMonth.value 
        //     // recordDate.getUTCFullYear() == selectedYear.value
        // );
       return record.gas_pressure_value.code === code.value &&
            recordDate.getMonth() + 1 === selectedMonth.value &&
            recordDate.getFullYear() === selectedYear.value;
    });
});


// function formatDateTimeUTC(date) {
//     return moment.utc(date) // ⬅️ ใช้ UTC
//         .locale('th')         // ภาษาไทย
//         .format('DD MMM YYYY HH:mm') // แสดงเวลาแบบไม่แปลง
//         .replace(`${moment.utc(date).year()}`, `${moment.utc(date).year() + 543}`); // แปลงปีเป็น พ.ศ.
// }
// function formatThaiDate(date) {
//     const m = moment(date).locale('th');
//     return m.format('D MMM YYYY').replace(m.year(), m.year() + 543);
// }

function clearFilters() {
    selectedMonth.value = today.getMonth() + 1;
    selectedYear.value = today.getFullYear();
}
function formatDateTimeUTC(dateStr) {
    const m = moment.utc(dateStr).locale('th');
    const buddhistYear = m.year() + 543;
    const month = m.format('MMM');
    const day = m.format('D');
    return `${day} ${month} ${String(buddhistYear).slice(2)}`; // ได้รูปแบบ '4 มิ.ย. 68'
}
const fetchDataCode = async () => {
    try {
        const response = await axiosInstance.get(`/check_gas_pressure_value/${code.value}`);
        form.value.group_id = response.data.group_id;
        form.value.gas_pressure_values_id = response.data.id;
        fetchData(response.data.id);
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

const fetchData = async (id) => {
    try {
        const [recordsRes, itemsRes, groupsRes] = await Promise.all([
            axiosInstance.get("/gas_pressure_value_records/value/" + id),
            axiosInstance.get("gas_pressure_value_items"),
            axiosInstance.get("group"),
        ]);

        gasInspectionRecords.value = recordsRes.data;
        gasInspectionItems.value = itemsRes.data;
        groups.value = groupsRes.data;

        // Get the current month and year in 'YYYY-MM' format
        const currentMonth = new Date().toISOString().slice(0, 7);

        // Check if any record has record_date within the current month
        const thisMonthRecord = recordsRes.data.some(record => {
            const createdAtMonth = new Date(record.record_date).toISOString().slice(0, 7);

            return createdAtMonth === currentMonth && record.gas_pressure_value.code === code.value;
        });

        // Show notification based on whether there is a record this month
        if (thisMonthRecord) {
            Toast.fire({
                icon: "success",
                title: "มีการบันทึกข้อมูลในเดือนนี้!"
            });
        } else {
            Toast.fire({
                icon: "error",
                title: "ยังไม่บันทึกข้อมูลในเดือนนี้!"
            });
        }
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

// const filteredRecords = computed(() => {
//     return gasInspectionRecords.value.filter(record =>
//         record.gas_pressure_values_id === Number(form.value.gas_pressure_values_id)
//     );
// });

const getDoctors = async () => {
    try {
        const res = await axios.get('https://api-hos.wanorn.com/backend/api/doctor');
        // doctors.value = res.data;
        doctors.value = res.data.filter(doctor => doctor.active !== "N");

    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

const handleSubmit = async () => {
    try {
        await axiosInstance.post('/gas_pressure_value_records', form.value);
        showSuccessAlert('บันทึกเรียบร้อยแล้ว!');
        // fetchData();
        fetchDataCode();
        hideModal();
        form.value = {
            recorder: "",
            group_id: "",
            gas_pressure_values_id: "",
            items: [],
        }
    } catch (error) {
        showErrorAlert('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    }
};

const showModal = () => modal.value.show();
const hideModal = () => modal.value.hide();

const openFormModal = () => {
    const now = moment();
    const currentDate = now.format('YYYY-MM-DD');
    const currentTime = now.format('HH:mm:ss');

    date.value = currentDate;
    time.value = currentTime;

    form.value.record_date = currentDate;
    form.value.record_time = currentTime;

    showModal();
};

const closeFormModal = () => {
    hideModal();
    const now = moment();
    const currentDate = now.format('YYYY-MM-DD');
    const currentTime = now.format('HH:mm:ss');

    date.value = currentDate;
    time.value = currentTime;

    form.value = {
        recorder: "",
        group_id: form.value.group_id,
        gas_pressure_values_id: form.value.gas_pressure_values_id,
        items: [],
        record_date: currentDate,
        record_time: currentTime,
    };
};

watch(date, (val) => {
    form.value.record_date = val;
});
watch(time, (val) => {
    form.value.record_time = val;
});

onMounted(() => {
    // fetchData();
    fetchDataCode();
    getDoctors();
    modal.value = new Modal(document.getElementById("Modal"));
});
</script>

<style scoped>
.login-wrapper {
    display: flex;
    height: 100vh;
}

.material-half-bg {
    flex: 1;
}

.login-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* .card {
  width: 100%;
  max-width: 500px;
  padding: 20px;
} */
.cover {
    background: url('@/assets/gas.jpg') no-repeat center center;
    background-size: cover;
    height: 100%;
    opacity: 0.3;
    /* Adjust opacity value as needed */
}
</style>